<template>
    <div id="MemberManagement">
        <div id="head">
            <div class="soso">
                <el-input v-model="formInline.user" placeholder="请输入名字/手机号/工号	" clearable
                    @keyup.enter.native="search('formInline')"></el-input>
                <el-button class="sosobtn" type="primary" @click="search()">
                    查询</el-button>
            </div>
            <div class="right-click">
                <el-button style="width: 160px; border-radius: 0px" id="DeleteSelected" type="primary"
                    class="checkBoctox" @click="dialogFormVisibleAll = true" v-show="StatusButtom">删除已选项</el-button>

                <el-button id="AddMembers" class="checkBoctox" style="width: 160px; border-radius: 0px" type="primary"
                    @click="addShow()">添加成员</el-button>
                <el-dialog class="checkbTn" title="确认删除已选中的成员信息吗？" :visible.sync="dialogFormVisibleAll">
                    <img class="OimG" src="../../assets/img/提示ICON.png" alt="" />
                    <p>从成员列表中彻底删除已选中的成员信息。</p>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisibleAll = false">取 消</el-button>
                        <el-button type="primary" @click="delAll">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
        <div id="fout">
            <div class="table-home">
                <table id="table" cellpadding="0" cellspacing="0">
                    <tr class="table-tr">
                        <th class="table-checkbox">
                            <input class="inp" type="checkbox" v-model="checked" v-on:click="checkedAll" />
                        </th>
                        <th class="table-index">序号</th>
                        <th class="table-th" v-for="item in list" :key="item.id">
                            {{ item.name }}
                        </th>
                    </tr>
                </table>

                <el-form :rules="rules" :model="res" ref="res" class="demo-ruleForm">
                    <table id="table" cellpadding="0" cellspacing="0">
                        <tr class="add-tr" v-if="IsShow > 0">
                            <td class="table-checkbox">
                                <input class="inp" type="checkbox" />
                            </td>
                            <td class="table-index">{{ data.length + 1 }}</td>
                            <td class="table-th">
                                <el-upload action="" class="avatar-uploader" :show-file-list="false"
                                    :before-upload="upData">
                                    <div id="logo">
                                        <img v-if="imageUrl !== ''" :src="imageUrl" class="avatar" />
                                        <img v-else :src="EnterpriseLogo" alt="" class="avatar" />
                                        <p>上传证件照</p>
                                    </div>
                                </el-upload>
                            </td>
                            <td class="table-th">
                                <el-form-item prop="name">
                                    <el-input placeholder="请输入" v-model.number="res.name">
                                    </el-input>
                                </el-form-item>
                            </td>
                            <td class="table-th">
                                <el-form-item prop="tel">
                                    <el-input placeholder="请输入" v-model="res.tel"> </el-input>
                                </el-form-item>
                            </td>
                            <td class="table-th">
                                <el-form-item prop="Eid">
                                    <el-input placeholder="请输入" v-model="res.Eid"> </el-input>
                                </el-form-item>
                            </td>
                            <td class="table-th">
                                <el-form-item prop="tab">
                                    <el-input placeholder="请输入" v-model="res.porment"> </el-input>
                                    <!-- <el-select v-model="res.porment">
                                        <el-option v-for="(item, index) in Eloption" :key="index" :label="item"
                                            :value="item"></el-option>
                                    </el-select> -->
                                </el-form-item>
                            </td>
                            <td class="table-th">{{ res.password }}</td>
                            <td class="table-th">
                                <el-link type="primary" :underline="false" @click.stop="addUser('res')">保存</el-link>
                                <el-link class="Onclick" type="primary" @click.stop="cancel()" :underline="false">取消
                                </el-link>
                            </td>
                        </tr>
                    </table>
                </el-form>

            </div>
            <div v-if="notFound == 1 && data.length > 0" class="table-home1">
                <el-form :model="Edit" ref="Edit" :rules="getEdits" class="demo-ruleForm">

                    <table id="table1" cellpadding="0" cellspacing="0">
                        <tr @click="downcheck(index + 1)" class="tr-td"
                            :class="{ activeBg: checkList.find((e) => e === index + 1) }" v-for="(abd, index) in data"
                            :key="index">
                            <td class="table-checkbox">
                                <span>
                                    <input class="inp" type="checkbox" v-model="checkList" :value="index + 1" />
                                </span>
                            </td>
                            <td class="table-index">{{ index + 1 }}</td>
                            <td class="table-th">
                                <img v-if="abd.status==true" class="oImg" :src="abd.img" alt="" />
                                <el-upload v-else action="" class="avatar-uploader" :show-file-list="false"
                                    :before-upload="UsersUpData">
                                    <div id="logo">
                                        <img v-if="pageImg !== ''" :src="pageImg" class="avatar" />
                                        <img v-else :src="pngLasa" alt="" class="avatar" />
                                        <p>更改证件照</p>
                                    </div>
                                </el-upload>
                            </td>
                            <td class="table-th"><span v-if="abd.status==true">{{ abd.realName }}</span>
                                <el-form-item v-else prop="realName">
                                    <el-input placeholder="请输入" v-model="Edit.realName">
                                    </el-input>
                                </el-form-item>
                            </td>
                            <td class="table-th"><span v-if="abd.status==true">{{ abd.tel?abd.tel:"--" }}</span>
                                <el-form-item v-else prop="classTel">
                                    <el-input placeholder="请输入" v-model="Edit.classTel">
                                    </el-input>
                                </el-form-item>
                            </td>
                            <td class="table-th">
                                <spam v-if="abd.status==true">{{ abd.jobNumber?abd.jobNumber:"--" }}</spam>
                                <el-form-item v-else prop="classEid">
                                    <el-input placeholder="请输入" v-model="Edit.classEid">
                                    </el-input>
                                </el-form-item>
                            </td>
                            <td class="table-th"><span
                                    v-if="abd.status==true">{{ abd.deptName?abd.deptName:"--" }}</span>
                                <el-form-item v-else prop="classEid">
                                    <el-input placeholder="请输入" v-model="Edit.classtab">
                                    </el-input>
                                </el-form-item>
                            </td>
                            <td class="table-th"><span v-if="abd.status==true">******</span>
                                <el-link type="primary" v-else :underline="false" @click="VisibleUpdataPass = true">重置密码
                                </el-link>

                                <el-dialog title="确认重置该成员的密码吗？" :visible.sync="VisibleUpdataPass">
                                    <img class="OimG" src="../../assets/img/提示ICON.png" alt="" />
                                    <p>重置后密码将改为初始密码“00000000”。</p>
                                    <div slot="footer" class="dialog-footer">
                                        <el-button @click="VisibleUpdataPass = false">取 消</el-button>
                                        <el-button type="primary" @click="palyPass(Edit.uid)">确 定</el-button>
                                    </div>
                                </el-dialog>
                            </td>
                            <td class="table-th">
                                <div class="table-th1" v-if="abd.status==true">
                                    <el-link type="primary" :underline="false" @click.stop="showOverlay(index)"
                                        style="text-decoration: none">编辑</el-link>
                                    <!-- @dialogForm="dialogForm" @childByvalue="childByvalue" -->
                                    <DiagramAnd @childByvalue="childByvalue" :Visible="dialogFormVisible"
                                        :value="abd.uid" :index="index"></DiagramAnd>
                                </div>
                                <div class="table-th1" v-else>
                                    <el-link type="primary" :underline="false"
                                        @click.stop="UpdateUser('Edit', Edit.uid)">保存
                                    </el-link>
                                    <el-link class="Onclick" type="primary" @click.stop="cancel1(index)" size="small"
                                        :underline="false">取消</el-link>
                                </div>
                            </td>
                        </tr>
                    </table>
                </el-form>
            </div>
            <div class="kong" v-else>
                <img class="notFound" src="../../assets/img/not_found_data.png" alt="" />
            </div>
        </div>
    </div>
</template>
<script>
    import Table from "../../components/EquipmentLedger/equipment/Table.vue";
    import {
        UPLOAD_IMAGE,
        UPDATE_USERUPDATA
    } from "../../api/upload";
    import {
        EnterpriseBackground
    } from "../../api/backstageManagement";
    import DiagramAnd from "./entcomponents/diagramAnd";
    export default {
        components: {
            Table,
            DiagramAnd
        },
        name: "MemberManagement",
        data() {
            var nameNum = (rule, value, callback) => {
                var n = /^[\u4E00-\u9FA5]{2,10}$/;
                if (value === "") {
                    callback(new Error("姓名不能为空"));
                } else if (n.test(value) !== true) {
                    callback(new Error("姓名格式必须中文长度2-10位"));
                } else {
                    callback();
                }
            };
            var TelNum = (rule, value, callback) => {
                var t = /^[1][3,4,5,7,8,9][0-9]{9}$/;
                if (value === "" || value.trim() === "") {
                    callback(new Error("手机号不能为空"));
                } else if (t.test(value) !== true) {
                    callback(new Error("手机格式必须11位正常手机号"));
                } else {
                    callback();
                }
            };
            // var EidNum = (rule, value, callback) => {
            //   var e = /^[0-9]+.?[0-9]*$/;
            //   if (value === "") {
            //     callback(new Error("工号不能为空"));
            //   } else if (e.test(value) !== true) {
            //     callback(new Error("工号必须是数字"));
            //   } else {
            //     callback();
            //   }
            // };
            return {
                //计时器隔一分钟刷一次
                timer: "",
                //按钮
                StatusButtom: false,
                //弹框
                VisibleUpdataPass: false,
                dialogFormVisible: false,
                dialogFormVisibleAll: false,
                //删除选中的uid
                abSub: [],
                //编辑更改图片
                pageImg: "",
                pngLasa: require("../../assets/img/userPng.png"),
                //编辑成员输入框
                Edit: {
                    id: "",
                    className: "",
                    classTel: "",
                    classEid: "",
                    classtab: "",
                    uid: "",
                    realName: "",
                },
                getEdits: {
                    realName: [{
                        validator: nameNum,
                        trigger: "blur"
                    }],
                    classTel: [{
                        validator: TelNum,
                        trigger: "blur"
                    }],
                    // classEid: [{ validator: EidNum, trigger: "blur" }],
                },
                //部门Id
                values: "",
                //添加模块
                //添加成员输入框
                res: {
                    name: "",
                    tel: "",
                    Eid: "",
                    porment: "",
                    password: "00000000",
                },
                rules: {
                    name: [{
                        validator: nameNum,
                        trigger: "blur"
                    }],
                    tel: [{
                        validator: TelNum,
                        trigger: "blur"
                    }],
                    // Eid: [{ validator: EidNum, trigger: "blur" }],
                },
                //添加成员备用图片
                imageUrl: "",
                EnterpriseLogo: require("../../assets/img/userPuc.png"),
                //添加成员for循环值 ,获取值
                Eloption: [],

                //单个编辑功能
                Information: 0,
                //add新增隐藏功能
                IsShow: 0,
                //搜索
                notFound: 1,
                formInline: {
                    user: "",
                },
                //table标题栏
                list: [{
                        id: 2,
                        name: "头像",
                    },
                    {
                        id: 3,
                        name: "名字",
                    },
                    {
                        id: 4,
                        name: "手机号",
                    },
                    {
                        id: 5,
                        name: "工号",
                    },
                    {
                        id: 6,
                        name: "部门",
                    },
                    {
                        id: 7,
                        name: "密码",
                    },
                    {
                        id: 8,
                        name: "操作",
                    },
                ],
                //table循环渲染
                data: [],
                // 勾选框
                checkList: [],
                //勾选内容框
                multipleSelection: [],
                //全选状态值
                checked: false,
                //勾选多个uid的数组
                itemUid: [],
                //获取企业ID
                firmId: "",
            };
        },
        watch: {
            //监听全选
            checkList: {
                handler: function (val, oldVal) {
                    // console.log(val);
                    if (val.length == 0) {
                        this.StatusButtom = false;
                    } else {
                        this.StatusButtom = true;
                    }
                    if (val.length == this.data.length) {
                        this.checked = true;
                    } else {
                        this.checked = false;
                    }
                },
                deep: true,
            },

            //监听这个变化的值
            "formInline.user": function (n, o) {
                // console.log(n, o);
                if (n != o) {
                    this.getTableData();
                    if (this.data.length > 0) {
                        this.notFound = 1;
                    } else {
                        this.notFound = 0;
                    }
                }
            },
        },
        created() {
            this.getTableData();
            this.timer = setInterval(() => {
                this.getTableData();
            }, 50000);
        },
        beforeDestroy() {
            clearInterval(this.timer);
        },
        methods: {
            //     //删除重新渲染
            childByvalue(index) {
                if (index) {
                    this.getTableData();
                }
            },
            // //渲染表格
            getTableData() {
                //初始渲染企业ID
                // console.log(this.$store.state.homeitem.user);
                this.firmId = this.$store.state.homeitem.user.firmId;
                EnterpriseBackground.projectUserAll(
                    this.$store.state.project.currentProject.projectId
                ).then((res) => {
                    // console.log(res.data.data)
                    let user = res.data.data.users.map((item) => {
                        let Showstatus = true;
                        item.status = Showstatus;
                        return item;
                    });
                    this.data = user;
                    // console.log(this.data)

                });
            },
            //   点击新增隐藏功能
            addShow() {
                this.IsShow = this.IsShow == 0 ? 1 : 0;
                if (this.IsShow == 1) {
                    this.Information = 0;
                }
            },
            //编辑弹框
            showOverlay(arr) {
                // this.Information = 1;
                // this.IsShow = 0;
                (this.res.name = ""),
                (this.res.tel = ""),
                (this.res.Eid = ""),
                (this.res.porment = ""),
                (this.res.password = "00000000"),
                this.data.forEach((item, index) => {
                    if (index == arr) {
                        item.status = false
                        // console.log(this.Eloption);
                        this.Edit.id = index + 1;
                        this.Edit.className = item.username;
                        this.Edit.classTel = item.tel;
                        this.Edit.classEid = item.jobNumber;
                        this.Edit.classtab = item.deptName ? item.deptName : this.Eloption[0];
                        this.Edit.uid = item.uid;
                        this.Edit.realName = item.realName;
                        this.pageImg = item.img;

                    } else {
                        item.status = true
                    }
                });
            },

            //勾选删除
            delAll() {
                // 已选择的数组
                // this.checkList: [1,2,3]
                this.dialogFormVisibleAll = false;
                // 表格数据
                // this.data
                let arr = this.data;
                this.checkList.forEach((item) => {
                    this.abSub.push(arr[item - 1].uid);
                    delete arr[item - 1];
                    // this.abSub = this.abSub;
                    //线上删除接口;
                    // console.log(this.abSub);
                });

                EnterpriseBackground.deletUsers(this.abSub).then((res) => {
                    // console.log(res);
                    // if(res.data.status){
                    this.$message({
                        type: "success",
                        message: "删除成功!",
                    });
                    this.abSub = [];
                    // }else{
                    //  this.$message.error("删除失败")
                    // }
                });
                //[1, ,3] 转化为[1,3]
                arr = arr.filter(function (n) {
                    return n;
                });
                // console.log(arr);
                this.data = arr;
                this.checkList = [];
            },
            //全选
            checkedAll() {
                if (this.checked) {
                    //实现反选
                    this.checkList = [];
                } else {
                    //实现全选
                    let arr = [];

                    this.data.forEach(function (item, index) {
                        // console.log(item);
                        arr.push(index + 1);
                    });
                    this.checkList = arr;
                }
            },
            //回车搜索框
            keyupEnter() {
                document.onkeydown = (e) => {
                    let body = document.getElementsByTagName("body")[0];
                    if (
                        e.keyCode === 13 &&
                        e.target.baseURI.match(/inputbook/) &&
                        e.target === body
                    ) {
                        // console.log("enter");
                        this.search();
                    }
                };
            },
            //搜索框点击之后重新渲染
            search() {
                // console.log(this.formInline.user);
                var v = this.formInline.user;
                let searchlist = [];
                if (v) {
                    let ss = [];
                    this.data.forEach((item) => {
                        // console.log(item);
                        if (item.tel) {
                            if (item.realName.indexOf(v) > -1) {
                                if (searchlist.indexOf(item.realName) == -1) {
                                    searchlist.push(item.realName);
                                }
                                ss.push(item);
                            } else if (item.tel.indexOf(v) > -1) {
                                if (searchlist.indexOf(item.tel) == -1) {
                                    searchlist.push(item.tel);
                                }
                                ss.push(item);
                            } else if (item.jobNumber.indexOf(v) > -1) {
                                if (searchlist.indexOf(item.jobNumber) == -1) {
                                    searchlist.push(item.jobNumber);
                                }
                                ss.push(item);
                            }
                        } else {
                            if (item.realName.indexOf(v) > -1) {
                                if (searchlist.indexOf(item.realName) == -1) {
                                    searchlist.push(item.realName);
                                }
                                ss.push(item);
                            } else if (item.jobNumber.indexOf(v) > -1) {
                                if (searchlist.indexOf(item.jobNumber) == -1) {
                                    searchlist.push(item.jobNumber);
                                }
                                ss.push(item);
                            }
                        }
                    });
                    this.data = ss;
                    // console.log(ss);
                    if (this.data.length > 0) {
                        this.notFound = 1;
                    } else {
                        this.notFound = 0;
                    }
                } else {
                    // 重新做数据请求进行赋值
                    this.getTableData();
                    this.notFound = 1;
                }
            },

            //添加成员头像
            upData(file) {
                const isJPG = file.type === "image/jpeg";
                const isLt2M = file.size / 1024 / 1024 < 2;
                const isPNG = file.type === "image/png";

                if (!isJPG && !isPNG) {
                    this.$message.error("上传头像图片只能是 JPG和PNG 格式!");
                    return false;
                }
                if (!isLt2M) {
                    this.$message.error("上传头像图片大小不能超过 2MB!");
                    return false;
                }
                UPLOAD_IMAGE(file).then((res) => {
                    // console.log(res.data.data.path);
                    this.imageUrl = res.data.data.path;
                });

                return false;
            },

            //添加成员取消按钮
            //编辑取消按钮
            cancel() {
                if (this.IsShow == 1) {
                    this.IsShow = 0;
                    (this.res.porment = ""),
                    (this.res.name = ""),
                    (this.res.tel = ""),
                    (this.res.Eid = ""),
                    (this.imageUrl = "");
                }
            },
            cancel1(arr) {
                this.data.forEach((item, index) => {
                    if (index == arr) {
                        item.status = true
                    }
                })
            },

            //添加成员保存按钮
            addUser(abc) {
                //判断部门this.Eloption
                this.$refs[abc].validate((valid) => {
                    if (valid) {
                        this.values = this.res.porment
                        // console.log(this.values, "我是部门")
                        EnterpriseBackground.registerUser(
                            this.firmId,
                            "00000000",
                            this.res.name,
                            "00000000",
                            this.res.tel,
                            //部门Id
                            this.values ? this.values : "",
                            this.imageUrl ? this.imageUrl :
                            `http://47.99.177.252:5505/images/users/default.png`,
                            this.res.Eid ? this.res.Eid : ""
                        ).then((res) => {
                            // console.log(res.data);
                            if (res.data.status) {
                                this.$message({
                                    message: "保存成功",
                                    type: "success",
                                });
                                this.IsShow = 0;
                                let arr = this.data;
                                // console.log(this.res.name, this.res.tel);
                                arr.push({
                                    img: this.imageUrl != "" ? this.imageUrl :
                                        `http://47.99.177.252:5505/images/users/default.png`,
                                    realName: this.res.name,
                                    tel: this.res.tel,
                                    deptName: this.res.porment,
                                    jobNumber: this.res.Eid,
                                });

                                this.data = arr;
                                this.getTableData();
                                this.imageUrl = "";
                                this.res.name = "";
                                this.res.tel = "";
                                this.res.Eid = "";
                                this.res.porment = "";
                            } else if (res.data.errMsg == "imgmust be a valid URL") {
                                this.getTableData();
                                this.$message.error("请选择一张图片");
                            } else if (res.data.errMsg == "手机号已被使用") {
                                this.getTableData();
                                this.$message.error("手机号已被使用，请重新输入！");
                            }
                        })
                    } else {
                        return false;
                    }
                });

                // console.log(this.data);
            },
            //重置密码
            palyPass(uid) {
                EnterpriseBackground.UserplayPass(uid).then((res) => {
                    // console.log(uid, res.data);
                    this.VisibleUpdataPass = false;
                    this.getTableData();
                    this.$message({
                        type: "success",
                        message: "密码重置成功!",
                    });
                });
            },
            //保存更新用户信息
            UpdateUser(form, uid) {
                this.$refs['Edit'].validate((valid) => {
                    if (valid) {
                        // console.log(valid)

                        this.values = this.Edit.classtab;
                        EnterpriseBackground.defaultUp(
                            uid,
                            this.pageImg ? this.pageImg : this.pngLasa,
                            this.Edit.realName,
                            this.Edit.classTel,
                            this.Edit.classEid ? this.Edit.classEid : "",
                            this.values ? this.values : "",
                            this.Edit.className
                        ).then((res) => {
                            // console.log(res);
                            if (res.data) {
                                // console.log(res.data);
                                this.getTableData();
                                this.$message({
                                    type: "success",
                                    message: "更改成功!",
                                });
                                this.Information = 0;
                                this.getTableData();
                            } else if (res.data.errMsg == "手机号已被使用") {
                                this.getTableData();
                                this.$message.error("手机号已被使用");
                            } else if (res.data.errMsg == "imgmust be a valid URL") {
                                this.getTableData();
                                this.$message.error("请选择一张图片");
                            }
                        });



                    } else {
                        // console.log(2222222)
                        return false;
                    }
                }); // console.log(this.Edit.classEid)
            },
            //用户头像信息更新
            UsersUpData(file) {
                const isJPG = file.type === "image/jpeg";
                const isLt2M = file.size / 1024 / 1024 < 2;
                const isPNG = file.type === "image/png";

                if (!isJPG && !isPNG) {
                    this.$message.error("上传头像图片只能是 JPG和PNG 格式!");
                    return false;
                }
                if (!isLt2M) {
                    this.$message.error("上传头像图片大小不能超过 2MB!");
                    return false;
                }
                // console.log(file);
                let uid = this.Edit.uid;
                UPDATE_USERUPDATA(file, uid).then((res) => {
                    // console.log(res.data);
                    this.pageImg = res.data.data.path;
                });
                return false;
            },

            //表格单独选中取消
            downcheck(abc) {
                if (this.checkList.includes(abc)) {
                    this.checkList.splice(
                        this.checkList.findIndex((item) => item === abc),
                        1
                    );
                    // document.querySelector(".tr-td").style.background = "#ffff !important" ;
                } else {
                    // console.log(222, abc);
                    this.checkList.push(abc);
                    //  document.querySelector(".tr-td").style.background = "#FD4238 !important";
                }
            },
        },
    };
</script>
<style scoped lang="less">
      .el-input__suffix {
    right: -138px !important;
    transition: all .3s;
}
    .activeBg {
        background: rgba(0, 43, 102, 0.06) !important;
    }

    #table1 {
        >tr {
            background: none;

            &:hover {
                background: rgba(0, 43, 102, 0.06) !important;
            }
        }
    }
  .sosobtn {
            width: 96px;
           line-height: 14px;
            margin-left:5%
        }
 
    #MemberManagement {
        width: 100%;
        height: 100%;
        background: #ffffff;
        box-shadow: 0rem 0rem 16rem 0rem rgba(0, 43, 102, 0.04);
        overflow: hidden;
 
        .table-th {
            width: 181px;
            white-space: nowrap;
            font-size: 16px;
            //  height: 80px;
        }

        .table-th1 {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 80px;
        }

        .table-index {
            width: 58px;
        }

        .table-checkbox {
            width: 46px;
        }

        .right-click {
            height: 40px;
            display: flex;
            justify-content: space-between;

            .checkBoctox {
                border-radius: 4px !important;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 18px !important;
            }
        }

      

        .kong {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .notFound {
                width: 372px;
                height: 240px;
            }
        }

        #logo {
            width: 48px;
            height: 48px;
            // position: relative;
            display: flex;
            align-items: center;

            img {
                width: 48px;
                height: 48px;
            }

            p {
                // position: absolute;
                top: 10rem;
                text-align: right;
                margin-left: 8px;
                white-space: nowrap;
                font-size: 14rem;
                color: #999999;
            }
        }

        .el-input {
            // width: 122px !important;
            height: 40px !important;
            color: #333333;
            font-size: 16px !important;
            padding: 0 5px !important;
        }

        .el-form-item {
            width: 122px !important;
            height: 40px !important;
            margin: auto;
        }

        .table-home {
            #table {
                width: 100%;
                height: 100%;
            }

            .add-tr {
                font-size: 16px;
                // width: 1600px;
                height: 80px;
                background: rgba(0, 43, 102, 0.06);
                text-align: center;

                #logo {
                    width: 48px;
                    height: 48px;
                    // position: relative;
                    display: flex;
                    align-items: center;

                    img {
                        width: 48px;
                        height: 48px;
                    }

                    p {
                        // position: absolute;
                        top: 10rem;
                        text-align: right;
                        margin-left: 8px;
                        white-space: nowrap;
                        font-size: 14rem;
                        color: #999999;
                    }
                }


                .el-input {
                    width: 122px !important;
                    height: 40px !important;
                    color: #333333;
                    font-size: 16px !important;
                    padding: 0 5px !important;
                }

                .el-form-item {
                    width: 122px !important;
                    height: 40px !important;
                    margin: auto;
                }

                .avatar {
                    width: 45rem;
                    height: 45rem;
                }
            }

            .table-tr {
                font-size: 19rem;
                font-weight: bold;
                color: #333333;
                height: 40px;
                background: rgba(0, 43, 102, 0.1);
            }

            .tr-td {
                text-align: center;
                line-height: 80px !important;
                font-weight: 400;
                color: #333333;
                font-size: 19rem;
            }

            .oImg {
                width: 48px;
                height: 48px;
            }
        }

        .table-home1 {
            height: 100%;
            width: 100%;
            overflow-y: scroll;

            #table1 {
                width: 100%;

                margin-bottom: 80px;
            }

            #table1 tr:nth-child(odd) {
                background: rgba(0, 43, 102, 0.02);
            }

            .tr-td {
                text-align: center;
                height: 80px;
                background: rgba(255, 255, 255, 0.04);
                font-weight: 400;
                color: #333333;
                font-size: 19rem;
            }

            .oImg {
                width: 48px;
                height: 48px;
            }
        }

        .table-home1::-webkit-scrollbar {
            width: 1px;
        }

        .Onclick {
            margin-left: 18px;
        }
    }
</style>